import AutoDismissFlag from '@atlaskit/flag/auto-dismiss-flag';
import FlagGroup from '@atlaskit/flag/flag-group';
import SuccessIcon from '@atlaskit/icon/core/status-success';
import { token } from '@atlaskit/tokens';
import { FormattedMessage, useIntl } from 'react-intl';

type NotInterestedConfirmationFlagProps = {
	onDismissed: () => void;
	onUndo: () => void;
};

export const NotInterestedConfirmationFlag = ({
	onDismissed,
	onUndo,
}: NotInterestedConfirmationFlagProps): JSX.Element => {
	const intl = useIntl();

	return (
		<FlagGroup>
			<AutoDismissFlag
				id="loom-meeting-nudge-not-interested"
				icon={<SuccessIcon label="" color={token('color.icon.success')} spacing="spacious" />}
				title={
					<FormattedMessage
						id="post-office.twc-loom-meeting-nudge-sidenav.not-interested-confirmation.title"
						defaultMessage="Meeting recording suggestions turned off"
						description="Title confirming that Loom meeting recording suggestions were turned off"
					/>
				}
				description={
					<FormattedMessage
						id="post-office.twc-loom-meeting-nudge-sidenav.not-interested-confirmation.description"
						defaultMessage="You won’t see meeting recording suggestions anymore."
						description="Description confirming that Loom meeting recording suggestions will no longer appear"
					/>
				}
				actions={[
					{
						content: intl.formatMessage({
							id: 'post-office.twc-loom-meeting-nudge-sidenav.not-interested-confirmation.undo',
							defaultMessage: 'Undo',
							description: 'Action to keep showing Loom meeting recording suggestions',
						}),
						onClick: onUndo,
					},
				]}
				onDismissed={onDismissed}
			/>
		</FlagGroup>
	);
};
